import { useState } from "react";
import { Flex, Button, Checkbox } from "antd";

import StyledModal from "./style";

import builder_welcome from "../../image/builder_welcome.png";

const ModalWelcomeModelBuilder = ({ onSuccess, open }) => {
  const [dontShowAgain, setDontShowAgain] = useState(false);

  return (
    <StyledModal
      closeIcon={false}
      footer={
        <Flex align="center" justify="space-between">
          <Checkbox
            onClick={e => setDontShowAgain(e.target.checked)}
            value={dontShowAgain}
          >
            Don't show again
          </Checkbox>

          <Button
            onClick={() => onSuccess({ dontShowAgain })}
            shape="round"
            type="primary"
          >
            Let's go
          </Button>
        </Flex>
      }
      open={open}
      width={580}
    >
      <h3>Welcome to Model Builder</h3>

      <Flex gap={24}>
        <Flex gap={2} flex="1 1 auto" vertical>
          <p style={{ fontSize: 18 }}>Build smarter portfolios in seconds.</p>
          <p>
            Our intuitive model builder lets you start with pre-built
            templates—like a classic 60/40 mix, globally diversified, or
            income-focused—or design your own from scratch. Tailor strategies to
            your goals, optimize allocations, and bring professional-grade
            portfolio construction to your fingertips.
          </p>
        </Flex>

        <Flex flex="1 0 161px">
          <img alt="builder welcome" src={builder_welcome} />
        </Flex>
      </Flex>
    </StyledModal>
  );
};

export default ModalWelcomeModelBuilder;
